import React, { useCallback, useMemo } from "react";
import { useStore } from "stores/connect";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import getForwarderInputsTableElements from "./Constants";
import forwarderInputColumnRenderers from "./ColumnRenderers";
import { fetchForwarderInputsList, keyFn } from "./usePaginatedForwarderInputs";
import FilterValueRenderers from "./FilterValueRenderers";
import ForwarderInputsRowActions from "./ForwarderInputsActions";
import useTableElements from "./useTableElements";
import ForwarderInputTypesStore from "../stores/ForwarderInputTypesStore";
const ForwarderInputsOverview = () => {
  const { forwarderInputTypes: inputTypes } = useStore(ForwarderInputTypesStore);
  const { tableLayout, additionalAttributes } = getForwarderInputsTableElements();
  const { expandedSections } = useTableElements();
  const columnRenderers = useMemo(() => forwarderInputColumnRenderers({ inputTypes: inputTypes || {} }), [inputTypes]);
  const entityActions = useCallback((input) => /* @__PURE__ */ React.createElement(ForwarderInputsRowActions, { input }), []);
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "forwarder inputs",
      additionalAttributes,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "forwarder input" }),
      entityActions,
      tableLayout,
      fetchEntities: fetchForwarderInputsList,
      keyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      filterValueRenderers: FilterValueRenderers,
      expandedSectionRenderers: expandedSections
    }
  );
};
export default ForwarderInputsOverview;
